var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"mx-auto",attrs:{"cols":"11","md":"10","lg":"8"}},[_c('h2',{staticClass:"page-view-title"},[_vm._v(_vm._s(_vm.$t("manageServicesTitle")))]),_c('assign-services-to-companies',{staticClass:"mt-15"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }